import { Snackbar, Alert } from '@mui/material';

const AUTO_HIDE_DURATION = 3000;

type Props = {
  message: string;
  type?: 'success' | 'info' | 'warning' | 'error';
  open: boolean;
  onClose: () => void;
};

const Toast = ({ message, open, type = 'success', onClose }: Props) => {
  return (
    <Snackbar open={open} autoHideDuration={AUTO_HIDE_DURATION} onClose={onClose}>
      <Alert onClose={onClose} severity={type}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Toast;
